// extracted by mini-css-extract-plugin
module.exports = {"packageCards":"Carrousel_packageCards__CIahx"};